import script from "./ClassSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassSummary.vue?vue&type=script&setup=true&lang=js"

import "./ClassSummary.vue?vue&type=style&index=0&id=edac882c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-edac882c"]])

export default __exports__